module.exports = __webpack_public_path__ + "static/ogThumbnail-5bb34da40dff7f4ad6df8d8456398704.jpg";